export default __webpack_public_path__ + "static/media/producto-01.62452347.jpg";